import { ApiSmpVision } from "@smp/api";
import { Await, dataArraySieve } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "smp.vision.translate";

export const useQueryVisionTranslate = (
  { strings, language }: Parameters<typeof ApiSmpVision.translate>[0],
  options?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpVision.translate>>>,
    "queryKey" | "queryFn"
  >,
) => {
  const nonNullableStrings = dataArraySieve(
    strings.map((string) => string.trim()),
  );

  const params = {
    language,
    strings: nonNullableStrings,
  };

  return useQuery<Await<ReturnType<typeof ApiSmpVision.translate>>>(
    [KEY, params],
    ({ signal }) =>
      ApiSmpVision.translate(
        {
          language,
          strings: nonNullableStrings,
        },
        signal,
      ),
    {
      ...(options || {}),
      enabled: !!nonNullableStrings.length && options?.enabled !== false,
    },
  );
};

useQueryVisionTranslate.KEY = KEY;
